<template>
	<div>
		<div class="bg-[#F5F2FB] h-full min-h-screen w-full">
			<SideBar class=""/>
			<TopBar class="z-50 hidden lg:block" />
			<main class="w-full h-full lg:pl-[250px]">
				<div class="px-2 lg:px-6 pt-14 lg:pt-0 overflow-x-hidden">
					<router-view class="mt-4 max-w-7xl px-2 lg:px-4 mx-auto mb-48" />
				</div>
			</main>
		</div>
	</div>
</template>

<script>
import SideBar from '@/components/navbars/SideBar';
import TopBar from '@/components/navbars/TopBar';

export default {
	name: "DashboardView",
	components: {
		SideBar,
		TopBar
	}
}
</script>
